module.exports = __webpack_public_path__ + "static/logo-dark-34d9f0b484842f876eb5fd0063b951a1.png";